export enum SignupStatuses {
   Initial = 'Initial',
   InformationVerified = 'InformationVerified',
   PasswordEntered = 'PasswordEntered',
   VerificationEmailSent = 'VerificationEmailSent',
   EmailVerified = 'EmailVerified',
}
